import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DialogSize } from '@models/dialog-size';
import { Theme } from '@models/theme';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from '@services/theme.service';
import { CreateThemeComponent } from '@theme/components/create-theme/create-theme.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'vnm-theming-dashboard',
  templateUrl: './theming-dashboard.component.html',
  styleUrls: ['./theming-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ThemingDashboardComponent implements OnInit {
  selectedTheme: Theme;

  constructor(
    public themeService: ThemeService,
    private translateService: TranslateService,
    private dialogService: DialogService
  ) {}

  ngOnInit() {
    this.selectedTheme = this.themeService.activeTheme;
  }

  selectTheme(event: any) {
    this.selectedTheme = this.themeService.getTheme(event.value.id);
  }

  newTheme() {
    const dialog = this.dialogService.open(CreateThemeComponent, {
      header: this.translateService.instant('create-theme.dialog-header'),
      styleClass: DialogSize.Small,
      dismissableMask: false,
      data: {
        themes: this.themeService.themes
      }
    });
    dialog.onClose.subscribe((theme) => {
      if (theme) {
        console.log('New Theme!', theme.name);
      }
    });
  }
}
